import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-535a9783"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb",
  class: "mx-4"
}
const _hoisted_2 = { class: "breadcrumb" }


export default /*#__PURE__*/_defineComponent({
  props: {
  breadcrumb: Array,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ol", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.breadcrumb, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(['breadcrumb-item fs-8', item.active ? 'active' : '']),
          key: item.content
        }, [
          _createVNode(_component_router_link, {
            to: item.to,
            class: _normalizeClass(['text-black hover-link', !item.to ? 'pe-none text-decoration-none' : ''])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.content), 1)
            ]),
            _: 2
          }, 1032, ["to", "class"])
        ], 2))
      }), 128))
    ])
  ]))
}
}

})